// src/helpers/contentfulHelper.js
// CMS content is fetched through our backend proxy (TDDS-3343) so the Contentful
// delivery token never ships in the bundle. The backend returns the same
// `{ items: [{ sys, fields }] }` shape the Contentful SDK used to, so callers are
// unchanged.
const CONTENT_API_BASE_URL = process.env.REACT_APP_CONTENT_API_BASE_URL;

// The gateway's Cognito authorizer only accepts the ID token (no OAuth scopes configured).
const getAccessToken = () =>
  localStorage.getItem('idToken') ||
  sessionStorage.getItem('idToken') ||
  localStorage.getItem('accessToken') ||
  sessionStorage.getItem('accessToken');

const fetchCollection = async (path, { authenticated = false } = {}) => {
  const headers = {};
  if (authenticated) {
    const token = getAccessToken();
    if (!token) throw new Error('Missing access token');
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${CONTENT_API_BASE_URL}${path}`, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    throw new Error(`Content request failed with status ${response.status}`);
  }

  const body = await response.json();
  return Array.isArray(body?.items) ? body.items : [];
};

export const fetchNewsItems = async () => {
  try {
    return await fetchCollection('/content/news', { authenticated: true });
  } catch (error) {
    console.error('Error fetching news items:', error);
    throw error;
  }
};

export const fetchSupportDocumentLinks = async () => {
  try {
    return await fetchCollection('/public/content/support-documents');
  } catch (error) {
    console.error('Error fetching support document links:', error);
    return [];
  }
};

export const fetchSupportVideos = async () => {
  try {
    return await fetchCollection('/public/content/support-videos');
  } catch (error) {
    console.error('Error fetching support videos:', error);
    return [];
  }
};
